import type { BrannanNavigation, DesignLayoutType } from '@graphql/generated';
import React, { createContext, useContext } from 'react';

export type LayoutContextValue = Readonly<{
  layout: DesignLayoutType;
  brannanNavigation?: BrannanNavigation;
}>;

export const LayoutContext = createContext<LayoutContextValue | undefined>(undefined);

export const LayoutProvider: React.FC<{ layout: DesignLayoutType; brannanNavigation?: BrannanNavigation }> = ({ children, layout, brannanNavigation }) => {
  return <LayoutContext.Provider value={{ layout, brannanNavigation }}>{children}</LayoutContext.Provider>;
};

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (context === undefined) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};
